
export default {
  orsDictionary: {
    unknown: 'Unbekannt',
    paved: 'Befestigt',
    unpaved: 'Unbefestigt',
    asphalt: 'Asphalt',
    concrete: 'Beton',
    cobblestone: 'Kopfsteinpflaster',
    metal: 'Metall',
    wood: 'Holz',
    compactedGravel: 'Verdichteter Kies',
    fineGravel: 'Feinkies',
    gravel: 'Kies',
    dirt: 'Erde',
    ground: 'Boden',
    ice: 'Eis',
    pavingStones: 'Pflastersteine',
    sand: 'Sand',
    woodchips: 'Holzhackschnitzel',
    grass: 'Gras',
    grassPaver: 'Rasengitterstein',
    none: 'Kein',
    no: 'Nein',
    customers: 'Kundenzugang',
    destination: 'Anlieger frei',
    delivery: 'Lieferverkehr',
    private: 'Privat',
    permissive: 'Geduldet',
    stateRoad: 'Bundesstraße',
    road: 'Landstraße',
    street: 'Straße',
    path: 'Weg',
    track: 'Pfad',
    cycleway: 'Radweg',
    footway: 'Fußweg/Gehweg',
    steps: 'Stufen',
    ferry: 'Fähre',
    construction: 'Im Bau',
    'concrete:lanes': 'Plattenweg',
    paving_stones: 'Pflastersteine',
    sett: 'Behauenes Steinpflaster',
    unhewn_cobblestone: 'Rohes Kopfsteinpflaster',
    compacted: 'Verdichtet',
    fine_gravel: 'Feinkies',
    pebblestone: 'Kieselsteine',
    impassable: 'Nicht passierbar',
    very_horrible: 'Sehr schrecklich',
    horrible: 'Schrecklich',
    very_bad: 'Sehr schlecht',
    bad: 'Schlecht',
    intermediate: 'Mittel',
    good: 'Gut',
    excellent: 'Ausgezeichnet',
    grade1: 'asserfester Belag',
    grade2: 'Wassergebundene Decke',
    grade3: 'Befestigter oder ausgebesserter Weg',
    grade4: 'Einfacher Weg',
    grade5: 'Unbefestigter Weg',
    no_tollway: 'Keine Mautstraße',
    is_tollway: 'Ist mautpflichtig',
    no_category: 'Keine Kategorie',
    highway: 'Autobahn',
    unpaved_road: 'Nicht asphaltierte',
    tunnel:	'Tunnel',
    paved_road:	'Asphaltierte',
    ford: 'Furt',
    no_data: 'Keine Daten'
  }
}
